const getDisplayMode = (rootState) => rootState.ui.aiChat.displayMode;

export default getDisplayMode;
